<template>

  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >

      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative resource-listing debtors"
          :items="fetchDebtors"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          selectable
          @row-selected="onRowSelected"
        >

          <!-- Column: User -->
          <template #cell(debtor)="data">
            <b-media vertical-align="center">
              <b-link
                :to="{ name: 'debtor-view', params: { id: data.item.debtor.id } }"
                class="font-weight-bold d-block text-nowrap client-name"
              >
                <div>
                  <div>{{ data.item.debtor.name }}</div>
                  <small class="text-muted">@{{ data.item.debtor.username }}</small>
                </div>
              </b-link>
            </b-media>
          </template>

          <!-- Column: Company -->
          <!-- <template
              v-if="1 < 0"
              #cell(company)="{data}"
            >
              {{ data.item.company }}
            </template> -->

          <!-- Column: Status -->
          <template #cell(error_message)="data">
            <b-link :to="{ name: 'debtor-view', params: { id: data.item.debtor.id } }">
              {{ getErrorMessage(data.item.response) }}
            </b-link>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-link>
              <feather-icon
                icon="ToolIcon"
                @click="fixRecord(data.item.debtor.id)"
              />
            </b-link>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay></div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BLink,
  // BDropdown, BDropdownItem,
  BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import UsersListFilters from './UsersListFilters.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import axios from '@axios'

export default {
  components: {
    // UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BLink,
    // BDropdown,
    // BDropdownItem,
    BPagination,

    vSelect,
    BOverlay,
  },
  data() {
    return {
      loader: false,
      fetchDebtors: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      constants,
      sortBy: 'id',
      isSortDirDesc: true,

    }
  },
  computed: {
    tableColumns() {
      const temp = [{ key: 'debtor', sortable: true, label: this.$t('DEBTIA_DEBTOR') },
        { key: 'action', sortable: false, label: this.$t('DEBTIA_ACTION') },
        { key: 'status', sortable: false, label: this.$t('DEBTIA_STATUS') },
        { key: 'error_message', sortable: false, label: this.$t('DEBTIA_ERROR_MESSAGE') },
        { key: 'actions', label: this.$t('DEBTIA_ACTION') },
      ]

      if (this.role === 'super-admin') {
        temp.splice(
          1, 0, { key: 'company', sortable: false, label: this.$t('DEBTIA_COMPANY') },
        )
      }

      return temp
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.getDebtors()
      },
    },
    perPage: {
      handler() {
        this.getDebtors()
      },
    },
    searchQuery: {
      handler() {
        this.getDebtors()
      },
    },
  },
  created() {
    this.getDebtors()
  },
  methods: {
    // actionColumn() {
    //   if (this.$ability.cannot(constants.action.permissionUserEdit, constants.resource.user) && this.$ability.cannot(constants.action.permissionUserDelete, constants.resource.user)) {
    //     this.tableColumns.splice(4)
    //   }
    // },
    async fixRecord(id) {
      this.loader = true
      const data = {
        debtor_id: id,
        is_aks_error: 1,
      }

      let text = ''
      let variant = ''
      let title = ''
      await axios.post('/aks/debtors/update', data).then(debtor => {
      // this.loader = false
        if (debtor.status) {
          text = 'Debtor status has been updated'
          variant = 'primary'
          title = 'Success'
          this.getDebtors()
        }
      }).catch(() => {
        text = 'Debtor status could not be updated'
        variant = 'warning'
        title = 'Failed'
      })
      this.showToast(title, variant, text)
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon: 'CoffeeIcon',
          variant,
          text,
        },
      })
    },
    getErrorMessage(response) {
      try {
        const res = JSON.parse(response)
        return res.Error?.Text || res.Text || res.error || ''
      } catch {
        return ''
      }
    },
    async getDebtors() {
      this.loader = true
      const debtors = await axios.get(`/aks/debtors/failed?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&sortDesc=true`)
      // this.loader = false
      if (debtors.status) {
        // console.log('cases', cases)
        this.fetchDebtors = debtors.data.data.data
        this.totalPages = debtors.data.data.total
        this.from = debtors.data.data.from
        this.to = debtors.data.data.to
        this.currentPage = debtors.data.data.current_page
        this.loader = false
      }
    },
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/debtors/view/${item['0'].debtor_id}`)
    },
  },
}
</script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
